import { Helmet } from 'react-helmet-async'
import Hero from '../sections/home/Hero'
import TrustOutcomes from '../sections/home/TrustOutcomes'
import SolutionsOverview from '../sections/home/SolutionsOverview'
import Industries from '../sections/home/Industries'
import FeaturedProjects from '../sections/home/FeaturedProjects'
import MoreProjects from '../sections/home/MoreProjects'
import ServicesAccordion from '../sections/home/ServicesAccordion'
import Testimonials from '../sections/home/Testimonials'
import CTABanner from '../sections/home/CTABanner'
import FAQ from '../sections/home/FAQ'

const schema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Technifire Software",
  "url": "https://technifire.io",
  "logo": "https://technifire.io/images/logo.png",
  "description": "Websites, SaaS products and AI automation systems engineered to generate leads, reduce manual work and support growth.",
  "foundingDate": "2020",
  "address": { "@type": "PostalAddress", "streetAddress": "8301 State Line Rd Ste 220 # 3747", "addressLocality": "Kansas City", "addressRegion": "MO", "postalCode": "64114-2025", "addressCountry": "US" },
  "contactPoint": { "@type": "ContactPoint", "telephone": "+1-425-541-4001", "contactType": "sales", "email": "info@technifire.io" },
  "sameAs": ["https://instagram.com/technifire", "https://facebook.com/technifire", "https://dribbble.com/technifire"]
}

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Web, SaaS & AI Development Company USA | Technifire</title>
        <meta name="description" content="Technifire builds conversion-focused websites, SaaS platforms and AI automation systems for US businesses. Book a free strategy call." />
        <link rel="canonical" href="https://technifire.io" />
        <meta property="og:title" content="Web, SaaS & AI Development Company USA | Technifire" />
        <meta property="og:description" content="Websites, SaaS products and AI automation systems engineered to generate leads, reduce manual work and support growth." />
        <meta property="og:url" content="https://technifire.io" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Hero />
      <TrustOutcomes />
      <SolutionsOverview />
      <FeaturedProjects />
      <MoreProjects />
      <ServicesAccordion />
      <Industries />
      <Testimonials />
      <CTABanner />
      <FAQ />
    </>
  )
}
